import { render, staticRenderFns } from "./GrmPagination.vue?vue&type=template&id=19b3072a&"
import script from "./GrmPagination.vue?vue&type=script&lang=js&"
export * from "./GrmPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b3072a')) {
      api.createRecord('19b3072a', component.options)
    } else {
      api.reload('19b3072a', component.options)
    }
    module.hot.accept("./GrmPagination.vue?vue&type=template&id=19b3072a&", function () {
      api.rerender('19b3072a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/pagination/GrmPagination.vue"
export default component.exports